import { render, staticRenderFns } from "./ConnectionsDetail.vue?vue&type=template&id=6f914b3a&"
import script from "./ConnectionsDetail.vue?vue&type=script&lang=ts&"
export * from "./ConnectionsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionsDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports